module.exports = __webpack_public_path__ + "static/img/banner1.1c8e4f13.png";